import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import "../../styles/components/Layout/LanguageSelector.css";

const LanguageSelector: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="language-selector">
      <button
        className={`lang-btn ${language === "es" ? "active" : ""}`}
        onClick={() => setLanguage("es")}
        title="Español"
      >
        🇪🇸 ES
      </button>
      <button
        className={`lang-btn ${language === "en" ? "active" : ""}`}
        onClick={() => setLanguage("en")}
        title="English"
      >
        🇺🇸 EN
      </button>
    </div>
  );
};

export default LanguageSelector;
